import { apiSlice } from '@/api/api.slice.tsx';

export interface StripeSetupIntentResponse {
  clientSecret: string;
}

const curr = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createSetupIntent: builder.mutation<StripeSetupIntentResponse, void>({
      query: () => ({
        url: '/create-stripe-setup-intent',
        method: 'POST',
      }),
    }),
  }),
});

export const { useCreateSetupIntentMutation } = curr;
